"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADDITIONAL_DETAILS_MAX_LENGTH = exports.URL_REGEX = exports.EMAIL_DOMAIN_REGEX = exports.EMAIL_REGEX = exports.PASSWORD_MIN_LENGTH = exports.ID_REGEX = exports.USERNAME_MIN_LENGTH = exports.USERNAME_MAX_LENGTH = exports.USERNAME_REGEX = void 0;
const url_regex_safe_1 = __importDefault(require("url-regex-safe"));
exports.USERNAME_REGEX = new RegExp(/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9_.]+$/);
exports.USERNAME_MAX_LENGTH = 30;
exports.USERNAME_MIN_LENGTH = 3;
exports.ID_REGEX = new RegExp(/^[a-zA-Z0-9-.]+$/);
exports.PASSWORD_MIN_LENGTH = 8;
exports.EMAIL_REGEX = new RegExp(/^\S+@\S+.\S+$/);
exports.EMAIL_DOMAIN_REGEX = new RegExp(/^[^@]\S+\.\S+$/);
exports.URL_REGEX = url_regex_safe_1.default({ exact: true, strict: true });
/**
 * ADDITIONAL_DETAILS_MAX_LENGTH defines the maximum length for the
 * additionalDetails field on a flag.
 */
exports.ADDITIONAL_DETAILS_MAX_LENGTH = 500;
